import { Cabinet } from 'lib/modelBuilder/entities/Cabinet';
import { put, select } from '@redux-saga/core/effects';
import { makeSelectCabinet } from 'containers/Configurator/selectors/furniture';
import { shelvesSelectionAction } from 'containers/Configurator/actions/selection';
import { getColors } from 'lib/modelBuilder/utils/dataStorage';
import { makeSelectShelvesLevelSelected } from 'containers/Configurator/selectors/selection';

// export function* postSuccessSupportSaga(cabinetNext: Cabinet, payload: any) {
//   const { preview } = payload;
//   if (!preview) {
//     const isVisiblePanel = yield select(selectIsVisibleSupportPanel());
//     if (isVisiblePanel) yield put(displaySupportPanel(false));
//   }
// }

export function* supportSaga(
  cabinetOrigin: Cabinet,
  cabinetNext: Cabinet,
  payload: any,
): any {
  const { support, height, material } = payload;
  cabinetNext.setSupport(support, height, material);
  return {
    ignore: false,
    postSuccess: null,
  };
}

export function* addingShelfSaga(
  cabinetOrigin: Cabinet,
  cabinetNext: Cabinet,
  payload: any,
): any {
  const { level } = payload;
  cabinetNext.addShelf(level);
  return {
    ignore: false,
    postSuccess: null,
  };
}

export function* postSuccessRemovingShelfSaga(
  cabinetNext: Cabinet,
  payload: any,
) {
  // We selected the closer shelf after a remove
  const selectedShelfsLevel: number[] = yield select(
    makeSelectShelvesLevelSelected(),
  );

  if (
    selectedShelfsLevel.length === 1 &&
    selectedShelfsLevel[0] === payload.level
  ) {
    if (payload.level >= cabinetNext.shelves.length) {
      if (cabinetNext.shelves.length === 1) {
        yield put(shelvesSelectionAction([]));
      } else {
        yield put(shelvesSelectionAction([cabinetNext.shelves.length - 1]));
      }
    } else {
      yield put(shelvesSelectionAction([payload.level]));
    }
  } else {
    if (payload.level === undefined && selectedShelfsLevel.length > 0) {
      yield put(shelvesSelectionAction([cabinetNext.shelves.length - 1]));
    }
  }
}

export function* removingShelfSaga(
  cabinetOrigin: Cabinet,
  cabinetNext: Cabinet,
  payload: any,
): any {
  const { level } = payload;

  if (level) {
    cabinetNext.removeShelf(level);
  } else {
    // If not specific level given we get all selected level from store
    const selectedShelfsLevel: number[] = yield select(
      makeSelectShelvesLevelSelected(),
    );
    const cabinet: Cabinet = yield select(makeSelectCabinet());
    if (
      selectedShelfsLevel.length > 0 &&
      selectedShelfsLevel.length < cabinet.shelves.length
    ) {
      // Don't delete if all shelves are selected
      for (const shelfLevel of selectedShelfsLevel) {
        cabinetNext.removeShelf(shelfLevel);
      }
    } else {
      return {
        ignore: true,
        postSuccess: null,
      };
    }
  }

  return {
    ignore: false,
    postSuccess: postSuccessRemovingShelfSaga,
  };
}

export function* cornersSaga(
  cabinetOrigin: Cabinet,
  cabinetNext: Cabinet,
  payload: any,
) {
  const { reference } = payload;
  const cornerOrigin = cabinetOrigin.getCorner();
  const colors = getColors();
  const color = colors.find(item => item.reference === reference);
  if (!color) throw new Error("Couldn't find the color");

  if (cornerOrigin && cornerOrigin.reference !== reference) {
    cabinetNext.updateCornersColor(color);
    return {
      ignore: false,
      postSuccess: null,
    };
  }
  return { ignore: true };
}

export function* fixToWallSaga(
  cabinetOrigin: Cabinet,
  cabinetNext: Cabinet,
  payload: any,
) {
  const { value } = payload;
  cabinetNext.setFixToWall(value);

  return {
    ignore: false,
    postSuccess: null,
  };
}
